import { Module } from 'vuex';
import { IRootState, IAdminLangState } from '@types';

import { ALangModel } from '@model';

import Env from '@lib/Env';

import { ALangApi } from '@/api';

const store: Module<IAdminLangState, IRootState> = {
    state: {
        langs: <ALangModel[]>[],
    },

    mutations: {
        setLangs: (state, records: ALangModel[]) => (state.langs = records),
    },

    getters: {
        getLangs: (state): ALangModel[] => state.langs,
    },

    actions: {
        loadLangs({ commit, getters }): Promise<ALangModel[]> {
            return new Promise((resolve, reject) => {
                ALangApi.loadLangs()
                    .then((response: any) => {
                        const records = [];
                        for (var i in response.data.records) {
                            records.push(new ALangModel(response.data.records[i]));
                        }
                        commit('setLangs', records);
                        resolve(records);
                    })
                    .catch((err: any) => {
                        Env.log.error(err);
                        reject(err);
                    });
            });
        },
    },
};

export default store;
